module.exports = `${require.publicPath}logo.ee82ba5f.png`;